import * as requestFromServer from './salesCrud';
import { salesSlice, callTypes } from './salesSlice';

const { actions } = salesSlice;

export const fetchSales = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .findSales(queryParams)
    .then((response) => {
      switch (response.data.type) {
        case 'SUCCESS':
        case 'SUCCESS_WITH_INFO':
        case 'SUCCESS_WITH_WARNING':
          console.log('SALES', response.data.data);
          const { totalCount, entities } = {
            totalCount: response.data.data.totalCount,
            entities: response.data.data.list,
          };
          dispatch(actions.salesFetched({ totalCount, entities }));
          break;
        default:
          var error = response.data.msg.desc;
          dispatch(actions.catchError({ error, callType: callTypes.list }));
          break;
      }
    })
    .catch((error) => {
      error.clientMessage = "Can't find sales";
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchSale = (saleCode) => (dispatch) => {
  if (!saleCode) {
    return dispatch(actions.saleFetched({ saleForView: undefined }));
  }

  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getSale(saleCode)
    .then((response) => {
      console.log(response.data);
      switch (response.data.type) {
        case 'SUCCESS':
        case 'SUCCESS_WITH_WARNING':
        case 'SUCCESS_WITH_INFO':
          dispatch(actions.saleFetched({ saleForView: response.data.data }));
          break;
        default:
          var err = response.data.msg;
          dispatch(actions.catchError({ err, callType: callTypes.action }));
          break;
      }
    })
    .catch((error) => {
      error.clientMessage = "Can't find sale";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const createSale = (sale) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .createSale(sale)
    .then((response) => {
      //console.log(response.data);
      switch (response.data.type) {
        case 'SUCCESS':
        case 'SUCCESS_WITH_WARNING':
        case 'SUCCESS_WITH_INFO':
          dispatch(actions.saleFetched({ saleForView: response.data.data }));
          dispatch(
            actions.sendMsg({
              msg: 'Амжилттай хадгаллаа!',
              callType: callTypes.action,
            })
          );
          break;
        default:
          var error = response.data.msg.desc;
          //console.log('createSale err', error);
          dispatch(actions.catchError({ error, callType: callTypes.action }));
          break;
      }
    })
    .catch((error) => {
      error.clientMessage = "Can't create sale";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};
export const updateSale = (saleForView) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateSale(saleForView)
    .then((response) => {
      //console.log('updateSale', response.data);
      switch (response.data.type) {
        case 'SUCCESS':
        case 'SUCCESS_WITH_WARNING':
        case 'SUCCESS_WITH_INFO':
          dispatch(actions.saleUpdated({ saleForView: response.data.data }));
          dispatch(
            actions.sendMsg({
              msg: 'Амжилттай хадгаллаа!',
              callType: callTypes.action,
            })
          );
          break;
        default:
          var error = response.data.msg.desc;
          dispatch(actions.catchError({ error, callType: callTypes.action }));
          break;
      }
    })
    .catch((error) => {
      error.clientMessage = "Can't update sale";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const closeOrder = (saleCode) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .closeOrder(saleCode)
    .then((response) => {
      //console.log('updateSale', response.data);
      switch (response.data.type) {
        case 'SUCCESS':
        case 'SUCCESS_WITH_WARNING':
        case 'SUCCESS_WITH_INFO':
          dispatch(actions.saleCreated({ saleForView: response.data.data }));
          dispatch(
            actions.sendMsg({
              msg: 'Захиалгыг хааж шинээр борлуулалт бүртгэлээ!',
              callType: callTypes.action,
            })
          );
          break;
        default:
          var error = response.data.msg.desc;
          dispatch(actions.catchError({ error, callType: callTypes.action }));
          break;
      }
    })
    .catch((error) => {
      error.clientMessage = "Can't close order";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const deleteSale = (saleCode) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteSale(saleCode)
    .then((response) => {
      switch (response.data.type) {
        case 'SUCCESS':
        case 'SUCCESS_WITH_WARNING':
        case 'SUCCESS_WITH_INFO':
          dispatch(actions.saleDeleted({ saleCode }));

          break;
        default:
          var err = response.data.msg;
          dispatch(actions.catchError({ err, callType: callTypes.action }));
          break;
      }
    })
    .catch((error) => {
      error.clientMessage = "Can't close sale";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const clearSale = () => (dispatch) => {
  dispatch(actions.saleCleared());
};
